var React = require('react');

function CloseIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M29.6985 9.89968C28.7873 8.98845 27.3099 8.98846 26.3987 9.89968L19.7988 16.4995L13.199 9.89966C12.2878 8.98844 10.8104 8.98844 9.89917 9.89966C8.98794 10.8109 8.98794 12.2883 9.89917 13.1995L16.499 19.7993L9.89952 26.3988C8.98829 27.3101 8.98829 28.7874 9.89952 29.6987C10.8107 30.6099 12.2881 30.6099 13.1993 29.6987L19.7988 23.0992L26.3983 29.6987C27.3095 30.6099 28.7869 30.6099 29.6982 29.6987C30.6094 28.7874 30.6094 27.31 29.6982 26.3988L23.0987 19.7993L29.6985 13.1995C30.6097 12.2883 30.6097 10.8109 29.6985 9.89968Z","fill":"white"}));
}

CloseIconInline.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = CloseIconInline;

CloseIconInline.default = CloseIconInline;
